import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useFormikContext } from 'formik';
import { Box, Text } from 'atoms';

const FormLabel = styled(Text)`
	display: block;
	font-size: 14px;
	font-weight: 500;
	color: #1c1c1c;
	margin-bottom: 8px;
`;

const ErrorMessage = styled(Text)`
	display: block;
	font-size: 13px;
	color: #ff4d4f;
	margin-top: 4px;
	line-height: 1.5;
`;

export default function FormField({ label, required, children, name }) {
	const { errors, touched } = useFormikContext();

	// Get error message for this field
	const error = name && errors[name];
	const isTouched = name && touched[name];
	const showError = isTouched && error;

	return (
		<Box mb="20px">
			<FormLabel>
				{label}
				{required && <span style={{ color: '#ff4d4f', marginLeft: '4px' }}>*</span>}
			</FormLabel>
			{children}
			{showError && <ErrorMessage>{error}</ErrorMessage>}
		</Box>
	);
}

FormField.propTypes = {
	label: PropTypes.string.isRequired,
	required: PropTypes.bool,
	children: PropTypes.node.isRequired,
	name: PropTypes.string,
};

FormField.defaultProps = {
	required: false,
	name: null,
};
